<div class="header">
  <img src="../../../assets/images/logo/flowtrics_logo.png">
</div>

<mat-card class="toolHolder" *ngIf="showPage==false">
  <div class="sepreator"></div>
  <p>link is expired.</p>

</mat-card>

<div class="container" *ngIf="showPage==true">
  <div class="requestholder">
   

    <div class="page_header">
      <div class="back">
      </div>
      <span>Please upload documents and save.</span>
    </div>


    <div class="step one" id="step1">
      
      <mat-card class="uploadDocuments">
      
          <div cdkDropList class="fileHolder" (cdkDropListDropped)="drop($event)">
            <div class="example-box" *ngFor="let file of UploadedFiles" cdkDrag>
              <ng-container *ngIf="!file.isDeleted">

                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

                <mat-card [ngClass]="file.isCompressed ? 'fileCont addCompress' : 'fileCont'">         

                  <div class="Icon"
                    *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">
                    <app-doc-icons [iconType]="'PDF'"></app-doc-icons>
                  </div>


                  <div class="Icon" *ngIf="file.documentType == 'doc' || file.documentType == 'docx'">
                    <app-doc-icons [iconType]="'WORD'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'xlsx' || file.documentType == 'xls'
                || file.documentType == 'xls'
                || file.documentType == 'csv'
                || file.documentType == 'ods'">
                    <app-doc-icons [iconType]="'EXCEL'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'jpg' || file.documentType == 'jpeg'
                || file.documentType == 'xls'
                || file.documentType == 'image/jpeg'">
                    <app-doc-icons [iconType]="'JPG'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'png' || file.documentType == 'tiff'
                || file.documentType == 'webp'">
                    <app-doc-icons [iconType]="'PNG'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'gif'">
                    <app-doc-icons [iconType]="'BMP'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'txt'">
                    <app-doc-icons [iconType]="'TEXT'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == 'ppt' || file.documentType == 'pptx'">
                    <app-doc-icons [iconType]="'PPT'"></app-doc-icons>
                  </div>

                  <div class="Icon" *ngIf="file.documentType == null">
                    <app-doc-icons [iconType]="'OTHER'"></app-doc-icons>
                  </div>

                  <div class="nameInfo">
                    <h2>{{ file.fileName }}</h2>
                    <p>{{ file.Totalsize }}</p>
                  </div>

                  <div class="docAct">

                    <button (click)="openDialogWithRef(myDialog, file)" mat-icon-button color="basic"
                      matTooltipClass="tooltip" matTooltip="Rename">
                      <mat-icon>font_download</mat-icon>
                    </button>

                    <button (click)="downloadPdf(file)" mat-icon-button color="basic" matTooltipClass="tooltip"
                      matTooltip="Download">
                      <mat-icon>cloud_download</mat-icon>
                    </button>

                    <button (click)="deleteFileFromUploaded(file)" mat-icon-button color="basic"
                      matTooltipClass="tooltip" matTooltip="Delete">
                      <mat-icon>cancel</mat-icon>
                    </button>

                  </div>

                </mat-card>

              </ng-container>
            </div>

            <mat-card class="documentList">
              <div class="uploadholder">
                <input #Input type="file" multiple (change)="selectFiles($event)"/>               
                <div class="textIn">
                  <p>Click or  here </p>
                  <span class="ml-5 mr-5">or</span>
                  <p>Drag and drop files</p>
                </div>
              </div>
             </mat-card>

          </div>       
  
      </mat-card>

    </div>

    <div class="mat-dialog-actions">      
      <button mat-flat-button color="primary" [disabled]="!ShowSubmitButton" (click)="SubmitDocument()">Save</button>
    </div>

  </div>

</div>

<ng-template #myDialog>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>description</mat-icon>
      </span>
      Rename Document
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>File Name</mat-label>
        <input matInput [required]="true" placeholder="Edit file name" formControlName="filename"
          [(ngModel)]="editfilename.filename" />
        <mat-error
          *ngIf="formDialog.get('filename').invalid && (formDialog.get('filename').dirty || formDialog.get('filename').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid" (click)="UpdateFileName()">
        Update
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>


<ng-template #AddEmailForUser>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>gesture</mat-icon>
    </span>

    <ng-container>
      Authentication for shared URL
    </ng-container>    
    
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container *ngIf="showAuthenticationType"> 
    <div class="title">Send token via</div>

    <div class="authopt">
      <mat-radio-button [checked]="true" value="1" color="primary" (change)="getTokenEmail($event)">
        <div class="thisinfo emailauth" fxLayoutAlign="start center" fxLayout="row">
            <mat-icon>email</mat-icon>
            <h3>Get code on email</h3>
        </div>
    </mat-radio-button>
    <mat-radio-button value="2" color="primary" (change)="getTokenMobile($event)">
        <div class="thisinfo smsauth" fxLayoutAlign="start center" fxLayout="row">
            <mat-icon>stay_current_portrait</mat-icon>
            <h3>Get code on sms</h3>
        </div>
    </mat-radio-button>
    </div>
</ng-container>

<mat-form-field *ngIf="showEmail" class="example-full-width">
  <mat-label>Email <span style="color:red"></span></mat-label>
  <input matInput placeholder="Enter email" required type="email" (input)="getEmailVerified()"
    [(ngModel)]="authenticationEmail"/>
</mat-form-field>

<mat-form-field *ngIf="showMobile" class="example-full-width">
  <mat-label>Mobile No. <span style="color:red"></span></mat-label>
  <input matInput placeholder="Enter Mobile No." required type="text"
    [(ngModel)]="authenticationMobile"/>
</mat-form-field>

   

    <mat-form-field *ngIf="tokenPanel" class="example-full-width">
      <mat-label *ngIf="Mobilesendtoken==false">Enter token sent to email</mat-label>
      <mat-label *ngIf="Mobilesendtoken==true">Enter token sent to mobile no.</mat-label>
      <input type="number" matInput placeholder="Enter Authentication Token" required 
       [(ngModel)]="otpCode"/>
    </mat-form-field>
   

  </mat-dialog-content>
  <mat-dialog-actions class="footer-action" >  
    <p class="timer" *ngIf="showTimeRemaining">Resend Token in {{display}}</p>
    <a class="resend" *ngIf="tokenotpCode" (click)="resendOTP()"> Resend Token</a>
    <button mat-flat-button *ngIf="verifyToken==0" [disabled]="sendTokenButton" (click)="sendToken()" color="primary">Send Token</button>
    <button mat-flat-button *ngIf="verifyToken>0" (click)="Authentication()" color="primary">Verify</button>
  </mat-dialog-actions>
</ng-template>


<div class="progress-loader" *ngIf="spinner">
  <div class="lds-ripple">
    <div></div>
    <div></div>
  </div>
</div>


<mat-card class="fileCont" *ngFor="let file of UploadingFiles">
  <div class="progress-loader">
    <div class="lds-ripple"><div></div><div></div></div>
  </div>
</mat-card>